if (!customElements.get('l-rudd-header')) {
	class LTARuddHeader extends HTMLElement {
		constructor() {
			super()
			this.handleClick = this.handleClick.bind(this)
			this.handleKeydown = this.handleKeydown.bind(this)
			this.handleDesktopChange = this.handleDesktopChange.bind(this)
			this.updateHeaderHeight = this.updateHeaderHeight.bind(this)
		}

		connectedCallback() {
			this.toggle = this.querySelector('[data-rudd-menu-toggle]')
			this.drawer = this.querySelector('[data-rudd-menu-drawer]')
			this.closeButton = this.querySelector('[data-rudd-menu-close]')
			this.desktopQuery = window.matchMedia('(min-width: 1024px)')

			this.addEventListener('click', this.handleClick)
			this.addEventListener('keydown', this.handleKeydown)
			this.desktopQuery.addEventListener('change', this.handleDesktopChange)

			this.resizeObserver = new ResizeObserver(this.updateHeaderHeight)
			this.resizeObserver.observe(this)
			this.updateHeaderHeight()
		}

		disconnectedCallback() {
			this.removeEventListener('click', this.handleClick)
			this.removeEventListener('keydown', this.handleKeydown)
			this.desktopQuery?.removeEventListener('change', this.handleDesktopChange)
			this.resizeObserver?.disconnect()
			this.closeMenu(false)
		}

		handleClick(event) {
			if (event.target.closest('[data-crossroads-cart-link]')) {
				// Deliberately no preventDefault: the cart drawer binds its own listener to
				// this trigger and cancels the event there. Cancelling it here too would
				// swallow the click even when the drawer is absent from the section group or
				// its script failed, leaving the cart unreachable. Letting the event through
				// means the anchor falls back to the cart page instead.
				this.closeMenu(false)

				return
			}

			if (event.target.closest('[data-rudd-menu-toggle]')) {
				this.openMenu()

				return
			}

			if (
				event.target.closest('[data-rudd-menu-close]') ||
				event.target.closest('[data-rudd-drawer-link]') ||
				event.target === this.drawer
			) {
				this.closeMenu()
			}
		}

		handleKeydown(event) {
			if (!this.classList.contains('is-menu-open')) return

			if (event.key === 'Escape') {
				event.preventDefault()
				this.closeMenu()

				return
			}

			if (event.key !== 'Tab') return

			const focusable = [...this.drawer.querySelectorAll('a[href], button:not([disabled])')].filter(
				(element) => element.offsetParent !== null
			)
			if (!focusable.length) return

			const first = focusable[0]
			const last = focusable[focusable.length - 1]

			if (event.shiftKey && document.activeElement === first) {
				event.preventDefault()
				last.focus()
			} else if (!event.shiftKey && document.activeElement === last) {
				event.preventDefault()
				first.focus()
			}
		}

		handleDesktopChange(event) {
			if (event.matches) this.closeMenu(false)
		}

		openMenu() {
			if (!this.toggle || !this.drawer || this.classList.contains('is-menu-open')) return

			this.previouslyFocused = document.activeElement
			this.classList.add('is-menu-open')
			this.toggle.setAttribute('aria-expanded', 'true')
			this.drawer.setAttribute('aria-hidden', 'false')
			document.documentElement.classList.add('l-rudd-menu-is-open')
			this.closeButton?.focus()
		}

		closeMenu(restoreFocus = true) {
			if (!this.toggle || !this.drawer) return

			this.classList.remove('is-menu-open')
			this.toggle.setAttribute('aria-expanded', 'false')
			this.drawer.setAttribute('aria-hidden', 'true')
			document.documentElement.classList.remove('l-rudd-menu-is-open')

			if (restoreFocus && this.previouslyFocused instanceof HTMLElement) this.previouslyFocused.focus()
		}

		updateHeaderHeight() {
			document.documentElement.style.setProperty('--l-header-height', `${this.offsetHeight}px`)
		}
	}

	customElements.define('l-rudd-header', LTARuddHeader)
}
